<div class="wrapper">
  <ul>
    @for(item of navigationItems | async; track item.routerLink) {

    <li
      routerLinkActive="active"
      [routerLink]="item.routerLink"
      queryParamsHandling="merge"
      [class.disabled]="item.disabled"
    >
      <ng-container *ngTemplateOutlet="icon; context: { icon: item.icon }" />
      <span>
        {{ item.labelKey | translate }}
      </span>
    </li>

    }
  </ul>
</div>

<ng-template #icon let-icon="icon">
  <cw-icon [icon]="icon" font="cortex" />
</ng-template>
